import { put, select, takeEvery } from 'redux-saga/effects';
import { Actions as RouterActions, Selectors as Router } from 'router';
import { CompleteWithEntity, Types } from '../';
import { Action } from '../ducks';

export type PathCreator = (siteId: string, entityId: string) => string;

function isEntityCreated<S>(action: Action<any, S>, service: S): boolean {
  return action.type === Types.CREATE_COMPLETED && action.service === service;
}

function isEntityUpdated<S>(action: Action<any, S>, service: S): boolean {
  return action.type === Types.UPDATE_COMPLETED && action.service === service;
}

function* redirect(entityId: string, pathCreator: PathCreator) {
  if (!entityId) {
    return;
  }

  const siteId = yield select(Router.getSiteId);
  if (!siteId) {
    return;
  }

  yield put(RouterActions.push(pathCreator(siteId, entityId)));
}

export function newRedirectAfterCreateSaga<S>(service: S, pathCreator: PathCreator) {
  return function* watchForCreation() {
    yield takeEvery(
      (action: Action<any, S>) => isEntityCreated(action, service),
      (action: CompleteWithEntity<any, S>) => redirect(action.payload.id, pathCreator),
    );
  };
}

export function newRedirectAfterUpdateSaga<S>(service: S, pathCreator: PathCreator) {
  return function* watchForUpdate() {
    yield takeEvery(
      (action: Action<any, S>) => isEntityUpdated(action, service),
      (action: CompleteWithEntity<any, S>) => redirect(action.payload.id, pathCreator),
    );
  };
}
